import * as React from "react";
const WishlistContext = React.createContext(void 0);
const useWishlistContext = () => {
  const context = React.useContext(WishlistContext);
  if (context === void 0) {
    throw new Error(
      "No WishlistProvider available. useWishlistContext must be used within a WishlistProvider so you need to wrap the application with the WishlistProvider."
    );
  }
  return context;
};
export {
  WishlistContext,
  useWishlistContext
};
//# sourceMappingURL=context.js.map
